import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';

export default DatePicker;
